<script setup lang='ts'>
import { ref, computed, onMounted, type Ref } from 'vue'
import { useUserStore } from '@/stores/user'
import { useFormStore } from '@/stores/form'
const formStore = useFormStore()
const userStore = useUserStore()

interface Transfer {
  fuseraccount: string
  fstate:string
  fplan: string
  famount: number
  fsetDate: string
  fcheckDate: string | null
  
}

const recentTransfers = ref<Transfer[]>([])


onMounted(async () => {
  // 假設 userStore 中有 useraccount 屬性
  if (userStore.account) {
    const rawTransfers = await userStore.getRecentTransfers(userStore.account)

    recentTransfers.value = rawTransfers.map((row: any[]) => ({
      fuseraccount: row[0],
      fstate:row[1],
      fplan: row[2],
      famount: parseFloat(row[3]),      
      fsetDate: row[4],
      fcheckDate: row[5]
      
    }))
  } else {
    console.error('未找到 useraccount')
  }
})

function gotovideo(){
    formStore.switchForm('video')
}
function formatDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime()) || date.getTime() === 0) return '';
  return date.toLocaleString();
}
</script>

<template>
  <div>
    <h2>最近轉帳紀錄</h2>
    <div class="dsh" v-if="recentTransfers.length > 0">
      <ul>
        <li v-for="(transfer, index) in recentTransfers" :key="index">
          <!-- <p>帳戶: {{ transfer.fuseraccount }}</p> -->
          <p>狀態: {{ transfer.fstate }}</p>
          <p>方案: {{ transfer.fplan }}</p>
          <p>金額: {{ transfer.famount }}</p>
          <p>匯款日期: {{ formatDate(transfer.fsetDate) }}</p>          
          <p v-if="formatDate(transfer.fcheckDate)">核查日期: {{ formatDate(transfer.fcheckDate) }}</p>
          
        </li>
      </ul>
    </div>
    <div v-else>
      <p>沒有可顯示的轉帳紀錄</p>
    </div>
    <button @click="gotovideo">返回</button>
  </div>
</template>
  
  <style scoped>
  /* 樣式範例 */

  .dsh{
    width: 600px;
    text-align: left;
    margin: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    align-self: center;
  }
  ul {
    list-style: none;
    padding: 0;
  }


li {
  background-color: black;         /* 黑色背景 */
  color: white;                    /* 白色字體 */
  border: 2px solid deeppink;      /* 粉紅色邊框 */
  border-radius: 15px;             /* 圓角 */
  padding: 15px;
  margin-bottom: 15px;
  font-size: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}





  button {
  margin: 15px 0;
  border-radius: 10px;
  border: none;
  color: white;
  font-size: 20px;
  background-color: deeppink;
  width: 400px;
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  align-self: center;
}
button:hover {
  transform: scale(1.04);
}
  </style>